var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4106 11.3447C11.5656 10.8672 11.8495 10.4422 12.2312 10.116C12.6129 9.7898 13.0778 9.57544 13.5737 9.49677C14.0696 9.4181 14.5772 9.478 15.0411 9.67004C15.505 9.86207 15.9068 10.1788 16.202 10.585C16.4972 10.9911 16.6739 11.4708 16.7134 11.9713C16.7529 12.4719 16.653 12.9737 16.4251 13.4211C16.1972 13.8684 15.8505 14.2438 15.4224 14.5061C14.9943 14.7685 14.502 14.9074 13.9999 14.9074V15.8152M13.9999 22.1668C9.48959 22.1668 5.83325 18.5105 5.83325 14.0002C5.83325 9.48984 9.48959 5.8335 13.9999 5.8335C18.5102 5.8335 22.1666 9.48984 22.1666 14.0002C22.1666 18.5105 18.5102 22.1668 13.9999 22.1668ZM14.0451 18.5372V18.6279L13.9547 18.6281V18.5372H14.0451Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.6fbc37aac4fd3d1c7c40a68ab927c4f7.svg";
export { ForwardRef as ReactComponent };